import moment from 'moment';

// import { useTranslation } from 'react-i18next';
import axios from '../Api/axios';
import { CLOUD_IMAGES_PROVIDER, CLOUDINARY_CONFIG, ROLES } from '../config';
import { allSubCategories, EnCoursString, rdvStatusEnum } from '../data/Interfaces';
import { formatDateJJMMYYYY } from './dateFormatter';
import { calculateDurationBetweenDatesISOFormat } from './getCalendarMonthMatrix';
// ? DATE FUNCTIONS
// dates must have the iso format ( ISO8601)
// moment().toISOString() // 2013-02-04T22:44:30.652Z {Z for UTC timestamp}
export function calculateWorkingDaysBetweenDates(startDate, endDate, nbJrsPartielPerWeek=5) {
    //* v1: just ouvrable days
    // ? https://askcodez.com/comment-calculer-le-nombre-de-jours-ouvrables-entre-deux-dates-en-javascript-a-laide-de-moment-js.html
    var day = moment(startDate);
    var businessDays = 0;
    while (day.isSameOrBefore(endDate,'day')) {
        if (day.day()!=0 && day.day()!=6) businessDays++;
        day.add(1,'d');
    }
    if(!isNaN(parseFloat(nbJrsPartielPerWeek)))
        return Math. trunc(businessDays - (
        // * si temps plien =? nbJoursPartielPerWeek ==5 => pas de substition
            (5 - nbJrsPartielPerWeek) *
        // * nbr des weeks dans cette duree
        calculateDurationBetweenDatesISOFormat(startDate, endDate)/7
        ));
    return businessDays;
}
export function convertMonthToDays(month){
    //à discuter
    return month*30;
}

export const getTimeFromIsoFormatDate=(date)=>{
    return moment(date)?.utc().format('HH:mm');
};

export const formatDateToRdvFormat = (dateString) => moment(dateString).format('DD-MM-YYYY hh:mm A');
export const isValidDate = (dateString) => new Date(dateString).toString() !== 'Invalid Date';

// ? //?****************

export default function randomColorGenerator() {
    var my = ['#E9ECF1'];
    return my[Math.floor(Math.random() * my.length)];
}

// ! Group array by property object of this array
// ? used to group the skills array BY NIVEAU [debutant ..]
export function groupBy(arr, prop) {
    // ! to prevent undifined array/ empy array from itterating
    if(arr == null) return;

    // Define the order
    const order = ['expert', 'avance', 'intermediaire', 'debutant',''];

    // Sort the array based on the 'niveau' property
    arr.sort((a, b) => order.indexOf(a.niveau) - order.indexOf(b.niveau));

    const map = new Map(Array.from(arr, obj => [obj[prop], []]));
    arr.forEach(obj => map.get(obj[prop]).push(obj));
    return Array.from(map.values());
}

export function SearchIfLangueExsit(entity,content) {
    entity.map((element) => {
        if(element==content)
            return true;
    });
    return false;
}

export function TestNullValue(val) {
    if(val!=null)
        return val;
    return ' ';
}

export function TestExistValue(val) {
    if(val && val!=undefined)
        return val;
    return '';
}

export function SearchIfSkillExsit(entity,content) {
    entity.map((element) => {
        if(element.titre==content)
            return true;
    });
    return false;
}

export function SearchNewElementEntityCV(entity,dateDeb,dateFin) {
    entity.map((element) => {
        if(element.dateDeb==dateDeb && element.dateFin==dateFin)
            return true;
    });
    return false;
}

export function SearchNewElementEntityCertif(entity,date) {
    entity.map((element) => {
        if(element.dateFin==date)
            return true;
    });
    return false;
}

export function StatutDocAdministratif(DocsAdministratifs) {
    var arrKbis=[];
    DocsAdministratifs.map(obj=>{
        if(obj.titre=='Kbis')
            arrKbis.push(obj);
    });
    //arrKbis.sort((a,b) => a.last_nom - b.last_nom);
    //console.log('kbis',arrKbis);
    return ' ';
}

export function Exigence(exigence){
    if(exigence=='requis')
        return 'Requis';
    if(exigence=='recommende')
        return 'Recommandé';
}

export function ValiderDocumentsAsigner(DocsAdministratifs,doc) {

    let statutDoc='nonValide';
    DocsAdministratifs.map((obj)=>{
        if(obj?.titre==doc){
            statutDoc= 'valide';
        }
    });
    return statutDoc;
}

export function ValiderDocAdministratifs(DocsAdministratifs,doc,statut='valide') {
    let statutDoc = 'nonValide';
    for (let i = 0; i < DocsAdministratifs.length; i++) {
        const obj = DocsAdministratifs[i];
        if (obj?.titre == doc && obj?.statut == statut) {
            statutDoc = 'valide';
            break; // exit the loop early if the document is found and valid
        }
    }
    return statutDoc;
}
export function ValiderDocAdministratifsClient(docsAdministratifs) {
    let hasValide = false;
    let hasExpire = false;
    let hasEncours = false;

    for (let i = 0; i < docsAdministratifs.length; i++) {
        const doc = docsAdministratifs[i];

        if (doc.statut === 'valide') {
            hasValide = true;
        } else if (doc.statut === 'expire') {
            hasExpire = true;
        } else if (doc.statut === 'encours') {
            hasEncours = true;
        }
    }

    if (hasValide) {
        return 'valide';
    } else if (hasExpire) {
        return 'expire';
    } else if (hasEncours) {
        return 'encours';
    } else {
        return 'rejete';
    }
}

export function ValiderDocAdministratifsExpert(docsAdministratifs) {
    //TODO attach avec non valider (x) , where x est le nbr des doc ( !valide ) expiree / encours /non Validee ..

    let res={statutDoc:'Non Validé',compteurDocNonValide:0};

    if(ValiderDocAdministratifs(docsAdministratifs,'kbis')!='valide')
        res.compteurDocNonValide+=1;
    if (ValiderDocAdministratifs(docsAdministratifs,'assurance')!='valide')
        res.compteurDocNonValide+=1;
    if(ValiderDocAdministratifs(docsAdministratifs,'attestationFiscale')!='valide')
        res.compteurDocNonValide+=1;
    if(ValiderDocAdministratifs(docsAdministratifs,'attestationURSSAF')!='valide')
        res.compteurDocNonValide+=1;
    if(ValiderDocAdministratifs(docsAdministratifs,'contrat','encours')!='valide')
        res.compteurDocNonValide+=1;
    if(ValiderDocAdministratifs(docsAdministratifs,'attestationHonneur','encours')!='valide')
        res.compteurDocNonValide+=1;
    if(ValiderDocAdministratifs(docsAdministratifs,'cinRecto')!='valide' || ValiderDocAdministratifs(docsAdministratifs,'passeport')!='valide' )
        res.compteurDocNonValide+=1;
    if(res.compteurDocNonValide==0)
        res.statutDoc= 'Validé';

    return res;
}

export function DateValidationEntrprise(DocsAdministratifs){
    let temp={isValide:false,dateValidation:null};
    if(DocsAdministratifs?.length>0){
        for (let i = 0; i < DocsAdministratifs.length; i++) {
            const obj = DocsAdministratifs[i];
            if (obj?.titre == 'kbis' && (obj?.statut == 'valide' || obj?.statut == 'expire') ) {
                temp = {isValide: true, dateValidation:formatDateJJMMYYYY(obj?.dateTraitement),statut:obj?.statut};
                break; // exit the loop early if the document is found and valid
            }
        }
    }
    return temp;
}

export function ValiderKbis(DocsAdministratifs) {
    let kbisValide={};
    DocsAdministratifs.map((obj)=>{
        if(obj?.titre=='kbis'){
            if(obj?.statut=='valide' || obj?.statut=='expire'){
                kbisValide=obj;
            }
        }
    });
    return kbisValide;
}
export function isNumber(number) {
    // 'use strict';
    if(typeof number == 'number' && !isNaN(number)){
        return true;
    }
    else if (typeof number == 'string'){
        number = number
        //replace all white spaces
            .replace(/\s/g,'').replace(/\./g, '')
        // replace , by .
            .replace(',', '.');
        return !isNaN(parseFloat(number)) && isFinite(number);
    }
    else return false;
}

export function addEuro(value,unit='€') {
    // console.log(typeof value, value);
    // if (typeof value === 'number' && !isNaN(value)) {
    //     return value + ' '+unit;
    //     // * v0
    //     // } else if (typeof value === 'string' && value.trim() !== '' && !isNaN(value.replace(/\s/g,''))) { //replace all white spaces
    //     // * v1: to not add unit to a non number value, and we will accept '12,5' '12.5' with white spaces
    // } else if (typeof value === 'string' && isNumber(value) ) {
    //     return value + ' '+unit;
    // }
    if(isNumber(value)){
        return value + ' '+unit;
    } else {
        return '';
    }
    // export function attachUnitToValue(unit, valueP) {
    //     // * v2
    //     if(valueP){
    //         if(unit){
    //             if(typeof unit == 'number'){
    //                 return '' + valueP + ' ' + unit;
    //             }
    //             else if(typeof unit == 'string'){
    //                 return '' + valueP + ' ' + unit + '##';
    //             }
    //             else{
    //                 return '' + valueP + ' ' + unit;
    //             }
    //         }
    //         else
    //             return valueP;
    //     }
    //     else
    //         return ' ';
    // }
}

export function referenceBdcClient(missionId) {
    var Temp=missionId.split('-');
    if(Temp.length>2)
        return 'PO-'+Temp[1]+'-'+Temp[2];
    else
        return 'PO-'+Temp[1];
}

export function calculateAppelsOffresOuverts(AOs){
    // * get AOs where status = ouvert : use the getStatutAO function
    var temp=0;
    AOs.forEach(ao=>{
        if(getStatutAO(ao?.dateDebutAO,ao?.dateFinAO)){
        // if(calculateDurationBetweenDatesISOFormat(new Date(),ao?.dateFinAO)>-1)
            temp=temp+1;
        }
    });
    return temp;
}

export function roleCollab(role){
    if(role==1)
        return true;
    return false;
}

export function verifySignataire(signataire, id){
    if (signataire?.isSignataireDiff == true) {
        return signataire?.signataireId === id;
    }
    return false;
}

// * collab client
export function statutCollaborateur(DemandeRejoindre,DemandeAcceptation,CompteActif){
    if(DemandeAcceptation==true && CompteActif==false)
        return 'enAttente';
    if((DemandeAcceptation==true && CompteActif==true) ||DemandeRejoindre==true)
        return 'actif';
    return 'aValider';
}

export function statutBackOfficeEnum(CompteActif){
    if(CompteActif==false)
        return 'enAttente';
    else if(CompteActif==true)
        return 'actif';
}

export function statutBdc(statutordreMission,statutPropositionCommercial,statutMission, isLastBDC){
    console.log('___isLastBDC___', isLastBDC ); // * on doit se rappeler de quelle statut qui s'applique juste sur le dernier BDC .. srtt on a encours comme statut par default ,
    //* si on a plusieurs bdc, et on a annuler / interrompre une mission => le derneire bdc doit avoir le statut Anulle/Interompu, et les autre (anciens) Valide.
    if(statutMission=='interompu')
        return 'Interrompu';
    else if(statutMission=='annulee')
        return 'Annulé';
    else if(statutMission=='terminee')
        return 'Terminé';
    else if(statutordreMission =='signe' && statutPropositionCommercial=='signe')
        return 'Validé';
    else
        return 'En cours';
}

export function visibilityBdc(statutordreMission,statutPropositionCommercial,statutMission){
    if(statutMission=='interompu')
        return false;
    else if(statutMission=='annulee')
        return false;
    else if(statutMission=='terminee')
        return false;
    else if(statutordreMission =='signe' && statutPropositionCommercial=='signe')
        return false;
    else
        return true;
}

export const getStatutMissionEnCoursSiDateDebutPasEncoreCommencee = (statutMission, dateDebutMission, isInterruptionEnCours) => {
    // * isInterruptionEnCours =  encours de demande
    if(isInterruptionEnCours) {
        return 'Interruption demandée';
    }
    else if (statutMission == EnCoursString) {
        if (isValidDate(dateDebutMission)) {
            let d1 = new Date(dateDebutMission);
            let today = new Date();
            if (today < d1) {
                return 'À venir';
                // return 'Commence bientôt';
            }
            else return statutMission;//* = the EnCoursString case
        }
        else return statutMission;//* = EnCoursString case
    }

    else return statutMission;//* Any Other statut (!= Encours)
};

export function searchLabelInEnumByValue(ArrayOfLabelsAndValues, inputValue){//enumList,searchedValue
    // * reda : was named getLabelFromEnumByValue inside interface
    if(Array.isArray(ArrayOfLabelsAndValues) && inputValue)
        for (const element of ArrayOfLabelsAndValues) {
            // console.log('element.value === inputValue',element.value,inputValue);
            if (element.value == inputValue) {
                return element.label;
            }
        }
    return inputValue ?? ' ';
}

export function cleanNanUndefinedValue(value){
    if(value && value!=undefined && !(isNaN(value)))
        return value;
    else
        return ' ';
}

export function searchValueLangueByLabel(enumList,value,lang){
    for (var i = 0; i < enumList.length; i++) {
        if (lang=='fr' && enumList[i]['label'].toLowerCase() == value) {
            return enumList[i]['value'];
        }
        if (lang=='en' && enumList[i]['value'].toLowerCase() == value) {
            return enumList[i]['value'];
        }
    }
    return '';

}

export function ordrePlusRecenteAuAncien(ListNonOrdonnee) {
    if (Array.isArray(ListNonOrdonnee)) {
        // Create a copy of the array
        const copiedList = [...ListNonOrdonnee];

        // Sort the copied array
        copiedList.sort(function (a, b) {
            var c = new Date(a.dateFin);
            var d = new Date(b.dateFin);
            return c - d;
        });

        // Find the index of the element with isEncours set to true
        //const indexToMove = copiedList.findIndex((item) => item.isEncours);

        // Filter out items with isEncours set to true
        const itemsWithEncours = copiedList.filter(item => item.isEncours);

        // Filter out items with isEncours set to false
        const itemsWithoutEncours = copiedList.filter(item => !item.isEncours);

        // Concatenate the two lists
        const sortedList = itemsWithEncours.concat(itemsWithoutEncours.reverse());
        //console.log('indexToMove', indexToMove);

        //if (indexToMove !== -1) {
        //    // If found, move the element to the end
        //    const elementToMove = copiedList.splice(indexToMove, 1);
        //    copiedList.push(elementToMove[0]);
        //}

        // Reverse the sorted array
        return sortedList;
    } else {
        return [];
    }
}

export function searchDuplicateClient(invitation,arrayDuplicate,arrayWithoutDuplicate){
    var temp=arrayWithoutDuplicate;
    var index;
    var tempObject;
    var index2;
    arrayDuplicate.forEach(element => {
        index = temp.findIndex(object =>  object.id  === element._id);
        tempObject = invitation.find(object => object.email === element?.persoData?.email);
        index2 = invitation.findIndex(object => object.email === element?.persoData?.email);
        //console.log('index2',index2,'object',element.email,'tempObject',tempObject);
        if (index === -1) {
            temp.push({
                'id':element?._id,
                'img':element?.persoData?.photo,
                'statut':index2!=-1 ? statutCollaborateur(tempObject?.accepted, tempObject?.wasInvitedToJoin,tempObject?.collaboratorData?.isActive) : 'actif',
                'role':element?.roles,
                'tele':element?.persoData?.tele,
                'nom':element?.persoData?.nom,
                'prenom':element?.persoData?.prenom,
                'email_':element?.persoData?.email,
                'nom_':getNomPrenomClearFromPersoData(element?.persoData)+','+ element?.persoData?.email,
                'isBlocked': tempObject?.collaboratorData?.isBlocked,
                tempObject,
                index2,
                index,
                invitation,
                arrayDuplicate,
                arrayWithoutDuplicate

            });
        }
    });

    return temp;
}

export function getCityCountryString(localisation) {
    if (!localisation) return '';
    return `${localisation?.name} / ${localisation?.country}`;
}
// to extract values as an array from an array of objects
export function extractValue(arr, prop) {
    // console.log(arr);
    // extract value from property
    let extractedValue = arr.map(item => item[prop]);
    return extractedValue;
}

export const refPropositionCommerciale = (missionId) => {
    if(missionId.split('-').length>1)
        return 'PRO-'+missionId.split('-')[1];
    return ' ';

};

export const referenceOrdreMission = (missionId) => {
    if(missionId.split('-').length>1)
        return 'TO-'+missionId.split('-')[1];
    return ' ';
};

export const calculateTotal = (quantite,prixUnitaire) => {
    if(quantite && prixUnitaire )
        return (quantite*prixUnitaire).toFixed(2);
    else if(!quantite && prixUnitaire)
        return prixUnitaire.toFixed(2);
    return 0;
};
export const getNomPrenomClearFromPersoData = (persoData) => {
    return (persoData?.prenom? persoData?.prenom.charAt(0).toUpperCase() : ' ') + (persoData?.prenom? persoData?.prenom.slice(1) : ' ')+ ' '+(persoData?.nom ? persoData?.nom.charAt(0).toUpperCase() : ' ') +(persoData?.nom ? persoData?.nom.slice(1) : ' ');
// const getNomPrenomClearFromPersoData = (persoData) => `${(persoData?.prenom ? persoData?.prenom.charAt(0).toUpperCase() : ' ') + (persoData?.prenom ? persoData?.prenom.slice(1) : ' ')} ${persoData?.nom ? persoData?.nom.charAt(0).toUpperCase() : ' '}${persoData?.nom ? persoData?.nom.slice(1) : ' '}`;
};

//ca impact la traduction il faut spliter le text compose
// export const getEntrepriseName = () => {
//     return 'High Tech Hires';
// };

export const UpperCasePrenomNom = (persoData) => {
    return persoData?.prenom.charAt(0).toUpperCase() + persoData?.prenom.slice(1)+' '+persoData?.nom.charAt(0).toUpperCase() + persoData?.nom.slice(1);
};

export const UpperCasePrenomNomFromAuth = (nom,prenom) => {
    return (prenom? prenom.charAt(0).toUpperCase() : ' ') + (prenom? prenom.slice(1) : ' ') +' '+ (nom ? nom.charAt(0).toUpperCase() : ' ') +(nom ? nom.slice(1) : ' ');
};

export const searchStringInsideSpecificPropetyOfArrayofObjects = ({array,property,searchedValue,categorie}) => {
    // console.log({array,property,searchedValue,categorie});
    //if there is nothing in the search localisation f4 eg, return all aos
    if(searchedValue== '' || !searchedValue) return array;
    // console.log('property',property);
    if(property=='categorie')
    {
        let obj;
        //console.log('array',array);
        return array.filter((expert) =>{
            obj = expert?.persoData;
            //console.log('obj',obj);
            // console.log('obj[property]',obj[property],obj[property] ? obj[property]['sousCategorie'].toLowerCase()+ '\t'+searchedValue.toLowerCase() : 'NO');
            if(obj[property]) {
                if(searchedValue.toLowerCase()==allSubCategories.toLowerCase()){
                    return obj[property]['value'].toLowerCase()==categorie.toLowerCase();}
                else
                    return obj[property]['value'].toLowerCase()==searchedValue.toLowerCase();
            }
        });
    }
    return array.filter((obj) =>{
        if(obj[property]) {return obj[property].toLowerCase()==searchedValue.toLowerCase();}
    });
};

export const getNomPrenomAnonymeFromPersoData = (persoData) => {
    return  (persoData?.nom.charAt(0).toUpperCase() || '') + '.' + (persoData?.prenom.charAt(0).toUpperCase() || '') ;
    // return 'TODO, search in the code for prenom.charAt(0)';
};

export const getNomPrenomAnonymeFromPersoDataFacture = (persoData) => {
    return  (persoData?.nom.charAt(0).toUpperCase() || '') + (persoData?.prenom.charAt(0).toUpperCase() || '') ;
    // return 'TODO, search in the code for prenom.charAt(0)';
};

export const isFactureG = (ref) => {
    if(ref)
        return ref.slice(-1) === 'G'; // or it has a list of 'factures' || 'facturesX' [my prefered one]
    return false;
};

export function statuRDV2ClassName(statut) {
    if (statut === rdvStatusEnum.planifie) {
        // return 'bg-blue-200 p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate';
        return {
            padding: '0.25rem',
            //marginBottom: '0.25rem',
            //marginRight: '0.75rem',
            backgroundColor: '#BFDBFE',
            color: '#4B5563',
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            borderRadius: '0.25rem',};

    }
    else if (statut === rdvStatusEnum.accepte) {
        // return 'bg-green-200 p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate';
        return {
            padding: '0.25rem',
            //marginBottom: '0.25rem',
            //marginRight: '0.75rem',
            backgroundColor: '#A7F3D0',
            color: '#4B5563',
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            borderRadius: '0.25rem',};
    }
    else if (statut === rdvStatusEnum.rejete) {
        // return 'bg-red-200 p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate';
        return {padding: '0.25rem',
            //marginBottom: '0.25rem',
            //marginRight: '0.75rem',
            backgroundColor: '#FECACA',
            color: '#4B5563',
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            borderRadius: '0.25rem',};
    }
    else if (statut === rdvStatusEnum.replanifie) {
        // return 'bg-gray-300 p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate';
        return {padding: '0.25rem',
            //marginBottom: '0.25rem',
            //marginRight: '0.75rem',
            backgroundColor: '#D1D5DB',
            color: '#4B5563',
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            borderRadius: '0.25rem',};
    }
}

export const CompareTwoString= (champ1,champ2) => {
    if(champ1!=champ2)
        return false;
    return true;
};

export const isHttpStatusSuccess= (statusCode) => {
    return statusCode >= 200 && statusCode < 300;
};

export const sortDate = (unsortedList)=>{
    // console.log('unsortedList',unsortedList);
    unsortedList.sort(function (a, b) {
        var c = new Date(a.Date);
        var d = new Date(b.Date);
        return d-c;
    });
    // console.log('after unsortedList',unsortedList);
    return unsortedList;
};

export const sortDatePublication = (unsortedList)=>{
    unsortedList.sort(function (a, b) {
        var c = new Date(a.dateDebutAO);
        var d = new Date(b.dateDebutAO);
        return d-c;
    });
    // console.log('after sort',unsortedList);
    return unsortedList;
};

export const  isUrlFromCompleterProfile = (url) => {
    return url.includes('completeProfile');
};

export const  isUrlFromRechercheAvance = (url) => {
    return url.includes('advanced');
};

//background white completeProfile client + welcomeCompletion
export const  isUrlWorthWhiteBackground = (url) => {
    return ((url.includes('completeProfile') && url.includes('completeProfile')) || (url.includes('welcomeCompletion')));
};

export const  isUrlFromParametreCompte = (url) => {
    return url.includes('parametreCompte');
};
export const  isUrlFromEntrePriseData = (url) => {
    return url.includes('donneesGenerales');
};
export const  isUrlFromDocAdministra = (url) => {
    return (url.includes('docAdmininstratif') || url.includes('docAdministrative'));
};
export const  isUrlFromProfilePerso = (url) => {
    return url.includes('profile');
};

export const  isUrlFromCandidature = (url) => {
    return url.includes('candidatures');
};

export const  isNonPermittedRoute = (pathName, role) => {
    // * nom permitted route = Not Home (cad last element is /client Ou /expert) && NotCompleteProfile && not Parametre compte
    let splittedPathBySlash = pathName.split('/'); // to see if it a a home path
    return !isUrlFromCompleterProfile(pathName)
    && !isUrlFromParametreCompte(pathName)
    && !isUrlFromProfilePerso(pathName)
    &&  splittedPathBySlash[splittedPathBySlash.length -1] !== role;
};
export const  isNonPermittedRouteForNewClientOwner = (pathName, role) => {
    // * nom permitted route = Not Home (cad last element is /client Ou /expert) && NotCompleteProfile && not Parametre compte
    let splittedPathBySlash = pathName.split('/'); // to see if it a a home path
    return !isUrlFromCompleterProfile(pathName)
    && !isUrlFromParametreCompte(pathName)
    // * added recently
    && !isUrlFromDocAdministra(pathName)
    && !isUrlFromEntrePriseData(pathName)
    && !isUrlFromProfilePerso(pathName)
    &&  splittedPathBySlash[splittedPathBySlash.length -1] !== role;
};

export const  isAuthentificatedRoute = (pathName) => {
    return pathName.includes('/expert/') || pathName.includes('/admin/') || pathName.includes('/client/');
};
export const  isUrlFromAoDescription = (pathName) => {
    let splittedPathBySlash = pathName.split('/');
    //* to see if we are on AO description : path="ao/:AOid"
    if(splittedPathBySlash[splittedPathBySlash.length -1].length == MONGODB_ID_LENGTH
        && splittedPathBySlash[splittedPathBySlash.length -2] =='ao')
    {
        return true;
    }
    else return false;
};

export const LabelSignaturePCOM  = (status) => {
    if(status=='rejete')
        return 'Date de rejet';
    else if(status=='signe')
        return 'Date de validation';
    else
        return 'Date';
};

export const MONGODB_ID_LENGTH = 24;

export const SpliUrl=(url)=>{
    var res='';
    if(url){
        var splitSlach=url.split('/');
        if(splitSlach[splitSlach.length - 1].length>19)
            return splitSlach[splitSlach.length - 1].substring(0, 15) + splitSlach[splitSlach.length - 1].slice(-4);
        else
            return splitSlach[splitSlach.length - 1].substring(0, 19);
        // var split2AntiSlach=url.split('//');
        // var split2Slach=url.split('\\');
        // if(split2Slach.length>1){
        //     res=split2Slach.pop();
        // }
        // else if (split2AntiSlach.length>1){
        //     res=split2AntiSlach.pop();
        // }
        // else if(splitSlach.length>1){
        //     res=splitSlach.pop();
        // }
    }
    // console.log(url, res); //the diff is https//
    return res;
};

export const getStatutInteruption = (isInterupted,motif) => {
    if(isInterupted==true && motif )
        return 'Rejté';
    if(isInterupted==false && motif )
        return 'Accepté';
};

export const calculateTotalAnneeExperience = (experiences) => {
    console.log('experiences', experiences);
    return Math.round(
        experiences?.reduce((acc, curr) => {
            const endDate = curr?.isEncours == true ? new Date() : curr?.dateFin;
            return acc + calculateMonthBetweenDatesISOFormat(curr?.dateDebut, endDate);
        }, 0) / 12//* months to years
    ) ?? 0;
};
export function calculateMonthBetweenDatesISOFormat(startDate, endDate) {
    //! the two dates must be in A ISO 8601 format [we are more clear now about required formats]
    // console.log(startDate,endDate);

    if (isValidDate(startDate) && isValidDate(endDate)) {
        var d1 = new Date(startDate);
        var d2 = new Date(endDate);
        return Math.round(Math.abs((d1 - d2) / 1000) / (2592000));
    } else return 0;
}

export const getExtensionUrl=(url)=>{
    var splitString;
    // console.log('url',url);
    if(url){
        splitString = url.split('.');
        // console.log('splitString',splitString);
    }
    return splitString.pop();
};

export const getExpertCompetences = (competencesTechnique) => {
    if(Array.isArray(competencesTechnique))
        return extractValue(competencesTechnique?.slice(0, 8), 'titre')?.join('- ');
    else return '-';
};

export const getDateDisponibilite = (dateDisponibilite) => {
    if(dateDisponibilite?.type ==  'immediate')
        return 'Immédiate';
    // * else is better than if(dateDisponibilite?.type ==  'aSpecifier')
    return formatDateJJMMYYYY(dateDisponibilite?.date);
};

export const getStatutCv = (statut,listStatut,id) => {
    let index = listStatut.findIndex(obj => {
        return obj.id === id;
    });
    if(index==-1)
        return ' ';
    else {
        if(listStatut[index]['statut'].includes(statut))
            return statut;
        else
            return ' ';
    }
};

export const getCodeFromRole = (userSelectedRole) => {
    if(userSelectedRole === 'client') return ROLES.Client;
    else if(userSelectedRole === 'expert') return ROLES.Expert;
    else if(userSelectedRole === 'esn') return ROLES.Esn;
};
export const getRoleFromCode = (codeRole) => {
    if(codeRole == ROLES.Admin) return 'admin';
    else if(codeRole == ROLES.Client) return 'client';
    else if(codeRole == ROLES.Expert) return 'expert';
    else if(codeRole == ROLES.Esn) return 'esn';
};

export const IMAGE_CONTEXT_ENUM = {
    collaboratorProfilePic: 'collaboratorProfilePic',
    expertProfilePic: 'expertProfilePic',
    clientlogo: 'clientlogo',
};

export const getUrlForAnImage = async (imageFile, axiosPrivate, imageContext) =>{
    // TODO: restrict 1 Mo on upload image: DONE BACKEND, STILL FRONT END
    // ! coudinary approach
    // cloud name dwk27zusp
    //   API Key 964664755469458
    // API Secret -u1a1pXHVqN7whHA4RxAk_1Ce-I
    // TODO: we will use React <> Cloudinary || react <> Node <> CLoudinary, and what are the cases, and also storing base 64 set and get if we want use mongo .. [profilePhoto ..]
    /**
cloud name : dwk27zusp
API Key : 964664755469458
API Secret : -u1a1pXHVqN7whHA4RxAk_1Ce-I
API Envirenoment CLOUDINARY_URL=cloudinary://964664755469458:-u1a1pXHVqN7whHA4RxAk_1Ce-I@dwk27zusp
upload_preset : m77ax10m
   */
    // https://www.geeksforgeeks.org/upload-and-retrieve-image-on-mongodb-using-mongoose/
    const data = new FormData();
    data.append('file', imageFile);
    if(CLOUD_IMAGES_PROVIDER == 'CLOUDINARY'){
        data.append('upload_preset', CLOUDINARY_CONFIG.upload_preset);
        data.append('cloud_name', CLOUDINARY_CONFIG.cloud_name);
        try {
            const response = await axios.post(CLOUDINARY_CONFIG.url,
                data,
            );
            return response.data?.url; //* url of the provided image
        } catch (error) {
            console.log(error);
        }
    }
    // !  AWS apprpoach
    else if(CLOUD_IMAGES_PROVIDER == 'AWS'&& imageContext in IMAGE_CONTEXT_ENUM){
        data.append('imageContext', imageContext);
        try {
            const response = await axiosPrivate.post('users/uploadProfilePic',data);
            return response.data?.url; //* url of the provided image
        } catch (error) {
            console.log(error);
        }
    }
    else return ''; //Error('BAD_CONTEXT')
};

// * we may use it later
export const updateOneElementAttributOfArrayOfElementsByIndex = ({arrayOfElements, attributeToSet, indexOfAttribute, value2Set, setarrayOfElements}) => {
    let newArr = [...arrayOfElements];
    newArr[indexOfAttribute][attributeToSet] = value2Set;
    setarrayOfElements(newArr);
};

// * we may use it later
export function addTiret(value) {
    if(value)
        return value;
    else
        return ('--');
}

export function getStatutAO(startDate, endDate) {
    if(isValidDate(startDate) && isValidDate(endDate)){
        let d1 = new Date(startDate);
        let d2 = new Date(endDate);
        let today = new Date();
        // Set time components to midnight
        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (today > d2) {
            return 'Clôturé';
        } else if (today >= d1 && today <= d2) {
            return 'Publié';
        } else {
            return 'Non publié';
        }
    }
}

// * a reusable function for deletinn element from an array By index and return the new array
export const handleRemoveElementFromArrayByIndex = (array, index) => {
    // Donnee cv Partagee : competencesTech competencesFonc- inputListCertifs langues experiencesList diplomes
    console.log('Before Deletion - array:', array);
    console.log('Index to Delete:', index);
    const list = [...array];
    list.splice(index, 1);
    console.log('after Deletion - array:', list);
    return list;
};

export const getEntrepriseInfoRoleBased = ({ info2Display, role, isVisible2Expert }) => {
    if(role == 'expert' || role=='esnExpert'){
        // console.log('isVisible2Expert',isVisible2Expert,'info2Display',info2Display);
        if (isVisible2Expert) {
            if(info2Display)
                return info2Display;
            else
                return 'Non précisé';
        }
        else return 'Non précisé';
    }
    else if (role == 'client' ||role == 'esnClient' || role == 'admin')
        return info2Display;
};

export function isANewUserWithoutAnyRole(obj) {
    for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key) && obj[key] !== 0) {
            return false;
        }
    }
    return true;
}

export function extractYearAndMonth(reference) {
    // Assuming the reference format is consistent (e.g., "FA{year}{month}...")
    const year = parseInt(reference.substr(2, 2)) + 2000; // Extract the first two digits as the year
    const month = parseInt(reference.substr(4, 2)); // Extract the next two digits as the month

    // Validate the extracted values
    if (isNaN(year) || isNaN(month) || year < 2000 || year > 2099 || month < 1 || month > 12) {
        return null; // Invalid reference format or out-of-range values
    }

    return { month, year };

    // // Convert 2-digit year to 4-digit year
    // const currentYear = new Date().getFullYear();
    // const fullYear = currentYear - (currentYear % 100) + year;

    // return { month, year: fullYear };
}
